import styled from 'styled-components';
import { deviceMax } from 'utils/styles/breakpoints';
import { FLEX_CONTAINER } from 'utils/styles/flex';

export const SocialMediaIcons = styled.div`
  ${FLEX_CONTAINER.FlexCenterRow};
  justify-content: center;
  margin: 16px 0px;
`;

export const FacebookIcon = styled.img`
  margin: 0px 10px;
  cursor: pointer;
  &:hover {
    opacity: 0.7;
  }

  @media only screen and ${deviceMax.mobileL} {
    width: 28px;
  }
`;

export const GoogleIcon = styled.img`
  margin: 0px 10px;
  cursor: pointer;
  &:hover {
    opacity: 0.7;
  }

  @media only screen and ${deviceMax.mobileL} {
    width: 28px;
  }
`;
